import React from 'react'

import {
  Link,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material'

import { formatMonthDayAndYear } from '$extensionSrc/utils/dateUtils'

import EnterpriseReportBox from './EnterpriseReportBox'
import styles from './OverviewSection.module.scss'

interface OverviewSectionProps {
  loading: boolean
  orgId?: string
  orgData?: {
    type?: string | null
    basicSetupDomains?: Array<string | null> | null
    promoCodes?: Array<string | null> | null
    ssoConfigs?: Array<{
      orgUrl?: string | null
      domains?: Array<string | null> | null
    } | null> | null
    planStartDate?: any | null
    planExpirationDate?: any | null
  }
}

export default function OverviewSection({
  loading,
  orgData,
  orgId,
}: OverviewSectionProps) {
  return (
    <EnterpriseReportBox
      content={
        <Table className={styles.overviewTable}>
          <TableBody>
            {orgData?.type === 'BASIC_SETUP' && (
              <TableRow>
                <TableCell>Email domains</TableCell>
                <TableCell>
                  {loading ? (
                    <Skeleton width={150} />
                  ) : (
                    orgData?.basicSetupDomains.join(', ') || 'Not configured'
                  )}
                </TableCell>
              </TableRow>
            )}
            {orgData?.type === 'SSO' && (
              <TableRow>
                <TableCell>Email domains</TableCell>
                <TableCell>
                  {loading ? (
                    <Skeleton width={150} />
                  ) : (
                    orgData?.ssoConfigs
                      .map((config) => config.domains?.join(', '))
                      .join(', ') || 'Not configured'
                  )}
                </TableCell>
              </TableRow>
            )}
            {orgData?.type !== 'SSO' && (
              <TableRow>
                <TableCell>Stripe promo codes</TableCell>
                <TableCell>
                  {loading ? (
                    <Skeleton width={100} />
                  ) : (
                    orgData?.promoCodes?.slice(0, 5).join(', ')
                  )}
                </TableCell>
              </TableRow>
            )}
            {orgData?.type === 'SSO' && (
              <TableRow>
                <TableCell>OAuth provider</TableCell>
                <TableCell>
                  {loading && <Skeleton width={200} />}
                  {!loading && orgData?.ssoConfigs?.[0]?.orgUrl && (
                    <Link
                      href={orgData.ssoConfigs[0].orgUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ textDecoration: 'underline' }}
                    >
                      {orgData.ssoConfigs[0].orgUrl}
                    </Link>
                  )}
                  {!loading &&
                    !orgData?.ssoConfigs?.[0]?.orgUrl &&
                    'Not configured'}
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell>Start Date</TableCell>
              <TableCell>
                {loading ? (
                  <Skeleton width={100} />
                ) : (
                  orgData?.planStartDate &&
                  formatMonthDayAndYear(orgData.planStartDate)
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>End Date</TableCell>
              <TableCell>
                {loading ? (
                  <Skeleton width={100} />
                ) : (
                  orgData?.planExpirationDate &&
                  formatMonthDayAndYear(orgData.planExpirationDate)
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>External Dashboard Preview Link</TableCell>
              <TableCell>
                {loading ? (
                  <Skeleton width={100} />
                ) : (
                  <a href={`https://enterprise.blockpartyapp.com/${orgId}`}>
                    enterprise.blockpartyapp.com/{orgId}
                  </a>
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      }
    />
  )
}
